export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-950 to-background-800 rounded-2xl overflow-hidden">
          <div className="flex flex-col md:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center md:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-semibold mb-4">随时吃瓜</span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">51黑料网 APP</h2>
              <p className="text-background-50/70 text-sm leading-relaxed mb-6 max-w-md">
                随时随地掌握娱乐圈最新动态，第一时间接收独家爆料推送。支持iOS和Android双平台，下载完全免费，吃瓜永不掉队！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                <a href="#app" className="w-full sm:w-auto px-6 py-3 rounded-lg bg-background-50 hover:bg-background-100 text-foreground-900 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors flex items-center justify-center gap-2">
                  <i className="ri-apple-line text-lg"></i>iOS 下载
                </a>
                <a href="#app" className="w-full sm:w-auto px-6 py-3 rounded-lg border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-all flex items-center justify-center gap-2">
                  <i className="ri-android-line text-lg"></i>Android 下载
                </a>
              </div>
            </div>
            <div className="flex-shrink-0 p-6 md:p-0 md:pr-10">
              <div className="w-40 h-72 md:w-48 md:h-80 bg-background-700 rounded-2xl border-2 border-background-600 overflow-hidden flex items-center justify-center">
                <div className="text-center px-3">
                  <div className="w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center mx-auto mb-3">
                    <span className="text-background-50 font-bold text-lg">51</span>
                  </div>
                  <span className="text-background-50/80 text-xs font-medium">扫码下载</span>
                  <div className="mt-3 w-24 h-24 bg-background-50/10 rounded-lg mx-auto flex items-center justify-center">
                    <i className="ri-qr-code-line text-3xl text-background-50/40"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}